function EscalationPlanItem() {
    "use strict";

    this.__type = 'EscalationPlanItem:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.AgentId = -1;
    this.ContactInterval = 0;
    this.ContactTypeId = -1;
    this.EscalationPlanId = -1;
    this.IsActive = true;
    this.SortOrder = -1;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = EscalationPlanItem;
}